module.exports = __webpack_public_path__ + "static/media/th-flag.ac78bb40.png";